import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useGenerateSetlist } from "../api/hooks/useGenerateSetlist";
import { useAudioPlayer } from "../contexts/AudioPlayerContext";
import LoadingEllipses from "../components/LoadingEllipses";
import {
  getStoredGenerateParams,
  setStoredGenerateParams,
  DEFAULT_GENERATE_PARAMS,
} from "../utils/generationParams";
import "./GeneratorPage.css";

function GeneratorPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {
    mutate: generateSetlist,
    isPending,
    isError,
    error,
  } = useGenerateSetlist();
  const { stopAndClear } = useAudioPlayer();

  useEffect(() => {
    // Stop and clear audio player when starting generation
    stopAndClear();

    // Auto-generate when page loads
    const era = searchParams.get("era");
    const jamminess = searchParams.get("jamminess");
    const sameShowSegues = searchParams.get("same_show_segues");

    const paramsFromQuery = {};
    if (era) paramsFromQuery.era = era;
    if (jamminess) {
      const jamValue = parseFloat(jamminess);
      if (!Number.isNaN(jamValue)) {
        paramsFromQuery.jamminess = jamValue;
      }
    }
    if (sameShowSegues === "true") {
      paramsFromQuery.same_show_segues = true;
    } else if (sameShowSegues === "false") {
      paramsFromQuery.same_show_segues = false;
    }

    const hasExplicitParams = Object.keys(paramsFromQuery).length > 0;
    const storedParams = getStoredGenerateParams();
    const baseParams =
      hasExplicitParams && Object.keys(paramsFromQuery).length
        ? paramsFromQuery
        : storedParams || {};

    const finalParams =
      baseParams.same_show_segues === undefined
        ? { ...DEFAULT_GENERATE_PARAMS, ...baseParams }
        : baseParams;

    setStoredGenerateParams(finalParams);

    generateSetlist(finalParams, {
      onSuccess: (data) => {
        // Navigate to setlist page with the generated data
        navigate("/setlist", { state: { setlist: data } });
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="generator-page">
      <main className="generator-content">
        {isPending && (
          <div className="generating-status">
            <div className="spinner"></div>
            <LoadingEllipses />
          </div>
        )}

        {isError && (
          <div className="error-message">
            <h3>Generation Failed</h3>
            <p>{error?.message || "Something went wrong. Please try again."}</p>
            <a href="/" className="btn">
              Back to Generator
            </a>
          </div>
        )}
      </main>
    </div>
  );
}

export default GeneratorPage;
